/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { getIn } from "formik";
import Select from "react-select";
import { CCol, CFormLabel, CInputGroup, CRow } from "@coreui/react-pro";

const SelectField = ({
  formik,
  label,
  name,
  type = "row",
  required = false,
  placeholder = "Pilih...",
  options = [],
  isMulti = false,
  isDisabled = false,
  isLoading = false,
  isError = false,
  value,
  handleChange,
  isClearable = true,
  isSearchable = true,
  helperText,
  labelClass,
  inputClass,
  parentClass,
  prefix,
  suffix,
}) => {
  const safeOptions = Array.isArray(options) ? options : [];

  // ambil nilai dari formik
  const fieldValue = formik ? getIn(formik.values, name) : undefined;

  // handle error dari formik
  const fieldError =
    formik && getIn(formik.touched, name) && getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;

  //  handle single & multi select value binding
  let selectedOption = null;
  if (isMulti) {
    if (Array.isArray(fieldValue)) {
      selectedOption = safeOptions.filter((opt) =>
        fieldValue.includes(opt.value),
      );
    } else {
      selectedOption = value || [];
    }
  } else {
    selectedOption =
      value ??
      safeOptions.find((opt) => opt.value === fieldValue) ??
      safeOptions.find((opt) => opt.label === fieldValue) ??
      null;
  }

  // default onChange untuk formik
  const defaultOnChange = (option) => {
    if (!formik) return;
    if (isMulti) {
      formik.setFieldValue(name, option ? option.map((opt) => opt.value) : []);
    } else {
      formik.setFieldValue(name, option ? option.value : "");
    }
  };

  // class & style untuk react-select
  const selectClassName = `react-select-container ${
    fieldError ? "is-invalid" : ""
  }`;

  const selectComponent = (
    <div style={{ flex: 1, minWidth: 0 }}>
      <Select
        id={name}
        name={name}
        className={selectClassName}
        classNamePrefix="react-select"
        placeholder={isLoading ? "Memuat data..." : placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled || isLoading}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        options={safeOptions}
        value={selectedOption}
        onChange={handleChange || defaultOnChange}
        onBlur={formik ? formik.handleBlur : undefined}
        styles={{
          container: (base) => ({
            ...base,
            width: "100%",
            flex: 1,
          }),
          control: (base, state) => ({
            ...base,
            width: "100%",
            borderColor: fieldError
              ? "#dc3545"
              : state.isFocused
                ? "#86b7fe"
                : base.borderColor,
            boxShadow: fieldError
              ? "0 0 0 0.2rem rgba(220,53,69,.25)"
              : state.isFocused
                ? "0 0 0 0.2rem rgba(13,110,253,.25)"
                : "none",
            "&:hover": { borderColor: fieldError ? "#dc3545" : "#86b7fe" },
          }),
        }}
      />
    </div>
  );

  return (
    <>
      {type === "col" && (
        <CRow className={`mt-3 ${parentClass || ""}`}>
          {label && (
            <CCol xs={12} sm={4} className="d-flex align-items-center fs-5">
              <CFormLabel htmlFor={name} className={`mb-0 ${labelClass}`}>
                {label}
              </CFormLabel>
            </CCol>
          )}
          <CCol xs={12} sm={8}>
            {prefix || suffix ? (
              <CInputGroup className={inputClass}>
                {prefix && prefix}
                {selectComponent}
                {suffix && suffix}
              </CInputGroup>
            ) : (
              <>{selectComponent}</>
            )}
            {/* Error handling */}
            {isError && (
              <div className="invalid-feedback d-block">
                Gagal memuat data {label?.toLowerCase()}
              </div>
            )}
            {helperText && (
              <div className="invalid-feedback d-block">{helperText}</div>
            )}

            {fieldError && (
              <div className="invalid-feedback d-block">{fieldError}</div>
            )}
          </CCol>
        </CRow>
      )}
      {type === "row" && (
        <div className={`mb-3 ${parentClass || ""}`}>
          {label && (
            <div>
              <CFormLabel htmlFor={name} className={labelClass}>
                {label}
              </CFormLabel>
              {required && <CFormLabel className="text-danger">*</CFormLabel>}
            </div>
          )}

          {prefix || suffix ? (
            <CInputGroup className={inputClass}>
              {prefix && prefix}
              {selectComponent}
              {suffix && suffix}
            </CInputGroup>
          ) : (
            <div className={inputClass}>{selectComponent}</div>
          )}

          {/* Error handling */}
          {isError && (
            <div className="invalid-feedback d-block">
              Gagal memuat data {label?.toLowerCase()}
            </div>
          )}
          {helperText && (
            <div className="invalid-feedback d-block">{helperText}</div>
          )}

          {fieldError && (
            <div className="invalid-feedback d-block">{fieldError}</div>
          )}
        </div>
      )}
    </>
  );
};

export default SelectField;
